import __request__ from "routing/request";
export function get() {
  return __request__("GET", "/system/urlallowlist", null, {}, {
    "Accept": ["application/json"]
  });
}
export function put(allowlist) {
  return __request__("PUT", "/system/urlallowlist", allowlist, {}, {
    "Accept": ["application/json"]
  });
}
export function check(JSONbody) {
  return __request__("POST", "/system/urlallowlist/check", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function generateRegex(JSONbody) {
  return __request__("POST", "/system/urlallowlist/generate_regex", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
